import React, { lazy } from "react";

export const VehicleManagementMetadata = {
  name: "Vehicle Management",
  id: "vehicle_management",
  component: lazy(() => import("../VehicleManagement/VehicleManagementPage")),
  route: "/vehicle_management",
  Breadcrumbs: true,
};
